import AwaitingUploadDocumentsModal from './AwaitingUploadDocumentsModal';

export default AwaitingUploadDocumentsModal;
